export default {
 buttons: {
   down: "Bas",
   up: "Haut",
 },
 tilt_angle: "Angle d'inclinaison",
 azimuth_angle: "Angle d'azimut",
 directions: {
   north: "Nord",
   south: "Sud",
   east: "Est",
   west: "Ouest",
 },

}
